import { isNull, isUndefined } from 'lodash';

export class FlipbookUrlHash {
  private isCustomerView: boolean;
  private isEditMode: boolean;
  private flipbookIdOrToken: string;
  private history: any;

  constructor(
    isCustomerView: boolean,
    isEditMode: boolean,
    flipbookIdOrToken: string,
    history: any
  ) {
    this.isCustomerView = isCustomerView;
    this.isEditMode = isEditMode;
    this.flipbookIdOrToken = flipbookIdOrToken;
    this.history = history;
  }

  private getCurrentPath() {
    const mode = this.isCustomerView
      ? 'customer-view'
      : this.isEditMode
      ? 'edit'
      : 'view';
    return `flipbook/${mode}/${this.flipbookIdOrToken}`;
  }

  public setHistoryHash(
    pageNumber: number,
    businessId: number,
    paramsStoreCode: string | null = null
  ): void {
    const currentPath = this.getCurrentPath();
    const urlParams = new URLSearchParams(window.location.search);
    const dt = urlParams.get('dataToken')! || '';
    this.history.push({
      pathname: `/${currentPath}/page/${pageNumber}?${
        !isNull(paramsStoreCode) ? `store=${paramsStoreCode}&` : ''
      }bu=${businessId}${!isUndefined(dt) ? `&dataToken=${dt}` : ''}`
    });
  }
}
